import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_SECTIONS,
  DELETE_SECTION,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { EnhancedTableStatusCell } from "@vocollege/components";

export default function Sections() {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/content/sections/${id}`);
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        title={I18n.get.section.labels.sections}
        operations={{
          category: "sections",
          get: GET_SECTIONS,
          delete: DELETE_SECTION,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.form.labels.title, field: "title" },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data) => <EnhancedTableStatusCell data={data.status} />,
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
      ></EnhancedTable>
    </Layout>
  );
}
